/**
 * @file: 卧柜cube注册
 * @author: xiaolong.huang@dmall.com
 */

import { Cube } from '../../cube/core/cube';
import init from './init';
import render from './render';
import update from './update';
import tpl from './freezerTpl';

export default function registFreezerCube(params?: FreeObjMap): void {
    Cube.registCube({
        cubeName: 'shelvesbuild-e-shelves-freezer',
        behavior: {
            tpl: $(tpl),
            dslot: 'J_ElementFreezerSlot',
            init: function() {
                init(this);
            },
            render: function() {
                render(this);
            },
            update: function(params: FreeObjMap = {}) {
                update({
                    onlyUpdateClass: params.onlyUpdateClass,
                    cube: this
                });
            }
        }
    });
}
